/* =============================================================================
   COBALTO — Aviso de reposición (Back in stock)
   Complementa el bloque liquid "cobalto_back_in_stock" de la página de producto.
   El formulario usa el endpoint nativo de contacto de Shopify (form_type=contact),
   por lo que el dueño recibe un email. Este script solo muestra el mensaje de
   éxito tras el envío (Shopify redirige con ?contact_posted=true) y evita que
   el usuario se quede sin feedback. Sin dependencias, sin apps.
   ============================================================================= */
(() => {
  function showSuccess() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('contact_posted') !== 'true') return;

    const box = document.getElementById('cobalto-bis');
    if (!box) return;

    box.innerHTML =
      '<p class="cobalto-bis__title">¡Gracias! Te avisaremos por correo en cuanto vuelva a estar disponible.</p>';
    box.classList.add('cobalto-bis--success');

    // Llevar el foco visual al mensaje sin saltos bruscos.
    window.requestAnimationFrame(() => {
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showSuccess);
  } else {
    showSuccess();
  }
})();
